import gql from "graphql-tag";

/**
 * pastEventsV2 — server-side filtered past events.
 * Replaces getCompanyEvents on the EventsCompleted page: the backend filters
 * to the last N months (default 3) on the DB index and projects only the
 * fields EventCard needs, instead of shipping the company's entire events
 * array to the client and filtering it in the browser.
 */
const pastEventsV2Query = gql`
  query pastEventsV2($companyId: String!, $monthsBack: Int) {
    pastEventsV2(companyId: $companyId, monthsBack: $monthsBack) {
      _id
      title
      instructor {
        _id
        firstName
        lastName
      }
      users {
        _id
        firstName
        lastName
        email
      }
      verifiedUsers {
        _id
        firstName
        lastName
        email
      }
      location
      date
      dateEnd
      totalSpots
      description
      image
      coins
      site
    }
  }
`;

export default pastEventsV2Query;
